import { useEffect, useRef } from "react";
import { useEnrollmentStatus } from "./useEnrollmentStatus";
import { useUiStore } from "@/shared/stores/uiStore";
import { useToastStore } from "@/shared/stores/toastStore";

const getAndClearEnrollmentIdFromUrl = (): string | null => {
  if (typeof window === "undefined" || !window.location.search) {
    return null;
  }
  const searchParams = new URLSearchParams(window.location.search);
  const id = searchParams.get("payment_method_enrollment_id");

  if (id) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete("payment_method_enrollment_id");
    window.history.replaceState(history.state, "", newUrl.toString());
  }
  return id;
};

export const useCardEnrollmentStatusHandler = () => {
  const { openModal, closeModal } = useUiStore();
  const { showToast } = useToastStore();

  const enrollmentIdRef = useRef<string | null>(
    getAndClearEnrollmentIdFromUrl(),
  );
  const hasHandled = useRef(false);
  const loadingModalShown = useRef(false);

  const { status } = useEnrollmentStatus(enrollmentIdRef.current);

  useEffect(() => {
    const enrollmentId = enrollmentIdRef.current;

    if (!enrollmentId || hasHandled.current) return;

    if (status === "created" && !loadingModalShown.current) {
      openModal("TOP_UP_BALANCE", { initialState: "loading" });
      loadingModalShown.current = true;
    }

    if (status === "succeeded" || status === "refunding") {
      hasHandled.current = true;
      closeModal();
      openModal("TOP_UP_BALANCE", { initialState: "success-card" });
    } else if (status === "failed") {
      hasHandled.current = true;
      closeModal();
      openModal("TOP_UP_BALANCE", { initialState: "error-card-exists" });
    } else if (status === "cancelled") {
      hasHandled.current = true;
      openModal("TOP_UP_BALANCE", { initialState: "error-topup" });
    }
  }, [status, openModal, closeModal, showToast]);
};
